import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=7f54a71e&scoped=true&"
import script from "./AdminSidebar.vue?vue&type=script&lang=ts&"
export * from "./AdminSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSidebar.vue?vue&type=style&index=0&id=7f54a71e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f54a71e",
  null
  
)

export default component.exports